import i18n, { TFunction } from "i18next";
import { SessionTemplate } from "../../domain/SessionTemplate";

/**
 * Gets the localized name of a template.
 * If it's a system template, it looks up the translation in templates.items.[name].name.
 * Otherwise, it returns the template's name as is.
 */
export function getTemplateName(template: SessionTemplate, t: TFunction, lng?: string): string {
    if (template.is_custom) return template.name;
    const finalT = lng ? i18n.getFixedT(lng) : t;
    const localized = finalT(`templates.items.${template.name}.name`, { defaultValue: template.name });
    return localized;
}

/**
 * Gets the localized description of a template.
 * If it's a system template, it looks up the translation in templates.items.[name].description.
 * Otherwise, it returns the template's description as is.
 */
export function getTemplateDescription(template: SessionTemplate, t: TFunction, lng?: string): string {
    if (template.is_custom) return template.description;
    const finalT = lng ? i18n.getFixedT(lng) : t;
    const localized = finalT(`templates.items.${template.name}.description`, { defaultValue: template.description });
    return localized;
}

/**
 * Gets the localized name of a template field.
 * It looks up the translation in templates.itemFields.[fieldName].
 * If no translation is found, it returns the field name as is.
 */
export function getFieldName(fieldName: string, t: TFunction, lng?: string): string {
    const finalT = lng ? i18n.getFixedT(lng) : t;
    const localized = finalT(`templates.itemFields.${fieldName}`, { defaultValue: fieldName });
    return localized;
}
